import NegotiationCount from '../../../component/atoms/NegotiationCount';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { actions } from '../../../redux/modules/Actions';
import { AppState } from '../../../redux/modules/store';
import { filterKeyState } from '../../../redux/reducers/CurrentFilterReducer';
import { SearchConditionState } from '../../../redux/reducers/SearchConditionReducer';
import moment from 'moment';

const nofilter: filterKeyState = {
  filterKey: '',
  filterTitle: '',
};

const mapStateToProps = (appState: AppState) => {
  return {
    isLoading: appState.loadingStatus.summary.isLoading,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    handleClick: (id: string, jobDateTime?: string) => {
      const searchCondition: SearchConditionState = [];

      // Step1. キーごとの検索条件を設定
      switch (id) {
        case 'total':
          if (jobDateTime) {
            const dStr = jobDateTime.replace(/^([0-9]{4})([0-9]{2})([0-9]{2})([0-9]{2})([0-9]{2})([0-9]{2})$/, '$1/$2/$3 $4:$5:$6');
            const d = new Date(dStr);
            if (!isNaN(d.getTime())) {
              searchCondition.push({
                searchConditionGroupId: 0,
                searchConditionName: 'actionDate',
                specifiedCondition: [null, moment(dStr).add(2, 'months').startOf('month').subtract(1, 'days').format('YYYYMMDD')],
              });
              searchCondition.push({
                searchConditionGroupId: 0,
                searchConditionName: 'negotiationProgressType',
                specifiedCondition: ['01', '00', '05'],
              });
            }
          }
          searchCondition.push({
            searchConditionGroupId: 2,
            searchConditionName: 'dummyFlg',
            specifiedCondition: ['true'],
          });
          searchCondition.push({
            searchConditionGroupId: 2,
            searchConditionName: 'undispFlg',
            specifiedCondition: ['0'],
          });
          searchCondition.push({
            searchConditionGroupId: 1,
            searchConditionName: 'productInfo',
            specifiedCondition: [null],
          });
          searchCondition.push({
            searchConditionGroupId: 0,
            searchConditionName: 'actionInfo',
            specifiedCondition: [null],
          });
          searchCondition.push({
            searchConditionGroupId: 1,
            searchConditionName: 'dummyFlg',
            specifiedCondition: ['false'],
          });
          searchCondition.push({
            searchConditionGroupId: 0,
            searchConditionName: 'undispFlg',
            specifiedCondition: ['0'],
          });
          searchCondition.push({
            searchConditionGroupId: 1,
            searchConditionName: 'undispFlg',
            specifiedCondition: ['0'],
          });
          break;
        case 'noneNegotiation':
          searchCondition.push({
            searchConditionName: 'dummyFlg',
            specifiedCondition: ['true'],
          });
          searchCondition.push({
            searchConditionName: 'undispFlg',
            specifiedCondition: ['0'],
          });
          break;
        case 'noneProduct':
          searchCondition.push({
            searchConditionName: 'productInfo',
            specifiedCondition: [null],
          });
          searchCondition.push({
            searchConditionName: 'dummyFlg',
            specifiedCondition: ['false'],
          });
          searchCondition.push({
            searchConditionName: 'undispFlg',
            specifiedCondition: ['0'],
          });
          break;
        default:
      }

      dispatch(actions.updateCurrentFilter(nofilter));
      dispatch(actions.updateSearchCondition(searchCondition));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NegotiationCount);
